/* ============
 * Account Module
 * ============
 */

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: {
    name: null,
  },
  actions,
  getters,
  mutations,
};
